import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  Menu,
  MenuItem,
  MenuSelectEvent,
  MenuItemLink,
} from "@progress/kendo-react-layout";
type handler = () => void;
interface externalNavProps {
    params: any;
    subMenuItem: string;
}
const ExternalNav = (props: externalNavProps) => {
  const [colWidth, setColWidth] = React.useState(180);

  const navigate = useNavigate();

  const backgroundMenuBig = {
    backgroundColor: "#1a171b",
    color: "white",
    fontSize: "1.1rem",
    padding: "2px",
    borderRight: "1px solid #454347",
  };
  const backgroundMenuBig1 = {
    backgroundColor: "#1a171b",
    color: "#4fb9ff",
    fontSize: "1.1rem",
    padding: "2px",
    borderRight: "1px solid #454347",
  };
  const onSelect = (event: MenuSelectEvent) => {
    openLink(event.item.data.name);
  };
    const openLink = (linkName) => {
  
    let params = "/";

      if (linkName == "home") {
          navigate("/search", { state: props.params });
    }
      else if (linkName == "serviceView") {
          navigate("/jiraReports", { state: props.params });
    } 


    else if (linkName == "globalView") {
      if (props.params.customerID != null) {
        params = params + "customerid=" + props.params.customerID;
      }
      window.open(
        "https://global-view.powerplatform.net/machinetimes" + params,
        "_self"
      );
    } else if (linkName == "user") {
      window.open(
        "https://fleetmgmt.powerplatform.net/default.aspx#/users",
        "_self"
      );
    } else if (linkName == "machineData") {
      const customer = props.params.customerID;
      if (props.params.mainMachineSerialNo != null) {
        params =
          "/customerid=" +
          customer +
          "&mainMachineSerialNo=" +
          props.params.mainMachineSerialNo;
      } else if (customer != null) {
        params = "/customerid=" + customer;
      }
      window.open("https://machinedata.powerplatform.net" + params, "_self");
    }
  };

    const getMenuItemStyle = (name: string) => {
        let selectedSection: string = "";
        if (props.subMenuItem == "/search" || props.subMenuItem == "/customers" || props.subMenuItem == "/NetworkDiagram") {
            selectedSection = "home"
        }
        else {
            selectedSection = "serviceView";
        }

        if (selectedSection == name) {
           
            return backgroundMenuBig1;
        }
        else {
            return backgroundMenuBig;
        }
    }

  return (
      <Menu onSelect={onSelect} vertical={false}>
        <MenuItem
            text="Home"
            data={{ name: "home" }}
              cssStyle={getMenuItemStyle("home")}
        />
        <MenuItem
        text="Service Tools"
        data={{ name: "serviceView" }}
              cssStyle={getMenuItemStyle("serviceView")}
      />
      <MenuItem
        text="Machine Analytics"
        data={{ name: "machineData" }}
        cssStyle={backgroundMenuBig}
      />
      <MenuItem
        text="Global Analytics"
        data={{ name: "globalView" }}
        cssStyle={backgroundMenuBig}
      />
    </Menu>
  );
};

export default ExternalNav;
